module.exports = __webpack_public_path__ + "assets/f5987ff04fbc4a48c7872e3d383dcad2.svg";